import Layout from '@/views/layout/Layout'

const umsMemberRoute = {
  path: '/ums/member',
  component: Layout,
  redirect: '/cms/member/list',
  name: 'ums.member',
  meta: { title: '用户', icon: 'ums' },
  children: [
    {
      path: 'list',
      name: 'ums.member.list',
      component: () => import('@/views/ums/member/list.vue'),
      meta: { title: '学生列表', icon: 'ums-admin' }
    },
    {
      path: 'enroll',
      name: 'ums.member.enroll.list',
      component: () => import('@/views/ums/member/enroll.vue'),
      meta: { title: '报名列表', icon: 'ums-admin' }
    },
    {
      path: 'qustion',
      name: 'cms.question.list',
      component: () => import('@/views/ums/member/question.vue'),
      meta: { title: '常见问题', icon: 'ums-admin' }
    },
  ]
}

export default umsMemberRoute



// WEBPACK FOOTER //
// ./src/router/module/umsMemberRoute.js